<div class="container-fluid col-md-12">
    <div class="row col-md-12">
        <div class="col-md-2 col-lg-2">
        <div class="form-group">
            <label>Market<span class="text-danger">*</span></label>
            <app-dropdown  #marketDropdown [list]="marketName" [isSingleSelect]="true" placeholder="Select" [title]="marketName"
            (itemChange)="onMarketChange($event)"
            class="dropdown-btn"></app-dropdown>
        </div>
        </div>
        <div class="col-md-2 col-lg-2">
            <div class="form-group">
                <label>Account Name<span class="text-danger">*</span></label>
                <app-dropdown #accountNameDropdown [list]="filteredAccountName" (itemChange)="onDropdownItemChange($event)"
                    [isSingleSelect]="true" [showOthers]="true" placeholder="Select">
                </app-dropdown>&nbsp;
                <input *ngIf="othersSelected" class="form-control" type="select" id="select" name="select"
                    [(ngModel)]="accountNameSelected" (keypress)="omitSpecialChar($event)" (change)=otherAccountNameValue($event.target.value)>
            </div>
        </div>
        <!-- <div class="col-md-2 col-lg-2">
            <div class="form-group">
                <label>Requested By<span class="text-danger">*</span></label>
                <app-dropdown #requestedByDropdown [list]="requestedBy" [isSingleSelect]="true" (itemChange)="onItemChange($event)"
                    [showOthers]="true" placeholder="Select" class="dropdown-btn"></app-dropdown> &nbsp;
                <input *ngIf="otherSelected" class="form-control" type="select" id="select" name="select"
                    [(ngModel)]="requestedBySelected" (keypress)="omitSpecialChar($event)" (change)=otherRequestedByValue($event.target.value)>
            </div>
        </div> -->
        <div class="col-md-2 col-lg-2">
            <div class="form-group">
                <label>Offshore Billable Hours<span class="text-danger">*</span></label>
                <app-dropdown #offBillableDropdown [list]="offBillableHours" [isSingleSelect]="true"
                    (itemChange)="onOffBliiableChange($event.item.name)" [showOthers]="true" placeholder="Select"
                    class="dropdown-btn"></app-dropdown>
            </div>
        </div>
        <div class="col-md-2 col-lg-2">
            <div class="form-group">
                <label>Onsite Billable Hours<span class="text-danger">*</span></label>
                <app-dropdown #onBillableDropdown [list]="onBillableHours" [isSingleSelect]="true"
                    (itemChange)="onOnBliiableChange($event.item.name)" [showOthers]="true" placeholder="Select"
                    class="dropdown-btn"></app-dropdown>
            </div>
        </div>
        <div class="col-md-2 col-lg-2">
            <div class="form-group">
                <label>Passcode<span class="text-danger">*</span></label>
                <!-- Passcode — avoid two-way binding -->
                <input
                #passcodeInput
                class="form-control"
                type="password"
                id="passcode"
                name="passcode"
                placeholder="Type Passcode"
                autocomplete="current-password"
                />
            </div>
        </div>
    </div>
    <!-- <div class="col-md-1" style="float: right;margin-top: -4.5%;white-space: nowrap;margin-right: 2%;">
        <button type="button" class="ct-btn tertiary-btn" (click)="onMarginClick(passcode)">Fetch Margin</button>
        &nbsp;
        &nbsp;
    </div> -->
</div>